import { render } from "./AppSubmenu.vue?vue&type=template&id=1f986d5c"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SanttuLehtinen\\Projektit\\kalmisto\\kalmisto-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__